import { render, staticRenderFns } from "./LbStatistics.vue?vue&type=template&id=9c46e186&scoped=true"
import script from "./LbStatistics.vue?vue&type=script&lang=js"
export * from "./LbStatistics.vue?vue&type=script&lang=js"
import style0 from "./LbStatistics.vue?vue&type=style&index=0&id=9c46e186&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c46e186",
  null
  
)

export default component.exports